import { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, orderDefaultValues } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import CustomLoader from "../component/menu/CustomLoader";
import { useParams } from "react-router-dom";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import OrderFormComponent from "../component/restaurants/orders/OrderFormComponent";
import { Spin } from "antd";
import { formatOrderEditableRecord } from "../services/order-details-service";
import { getIdWiseFoods, getQueryParamsOrderForm, restoreStockOnOrderEdit } from "../services/order-add-edit-service";
import OrderFormHeaderComponent from "../component/OrderFormHeaderComponent";
import { initOrderEditTableSession } from "../services/order-table-base-service";
import { storeOrderedFoodsInSession } from "../utils/Common";

export default function OrderEdit() {
  const { user, restaurantId, showNotification } = useUserStore();
  const params = useParams();
  const {orderId} = params;
  const {isTableManagement} = getQueryParamsOrderForm();
  const [availableCategories, setAvailableCategories] = useState([]);
  const [availableFoods, setAvailableFoods] = useState(null);
  const [loadAvailableFoods, setLoadAvailableFoods] = useState(false);
  const [orderRecord, setOrderRecord] = useState({...orderDefaultValues});
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedFood, setSelectedFood] = useState("");
  const [totalAvailableFoods, setTotalAvailableFoods] = useState([]);

  const fetchRestaurantCategories = () => {
    let params = {
      restaurantId,
    };
    const token = user.token.token;
    ApiService.GET_CATEGORY(params, token).then((res) => {
      if (!res || (res && res.code !== 200)) {
        showNotification(res.data.message || "Something went wrong. Please try again later!");
        return;
      }

      setAvailableCategories(res.payload.records);
    });
  };

  const fetchFoodList = async () => {
    let params = { restaurantId };

    const token = user.token.token;
    const res = await ApiService.FOOD_SET_MENU_LIST(params, token);

    if (res.code === 200) {
      return res.payload.records;
    }
    
    return [];
  };

  async function getOrder(orderId) {
    const token = user.token.token;
    const res = await ApiService.FETCH_ORDER_DETAILS(orderId, token);

    if (res.code !== 200) {
      showNotification("Failed to fetch order details.");
      return null;
    }

    const data = res.payload.record;

    return data;    
  }

  const fetchFoodsAndOrder = async(orderId) => {
    setLoadAvailableFoods(true);
    const [foods, order] = await Promise.all([fetchFoodList(), getOrder(orderId)]);

    setLoadAvailableFoods(false);
    const idWiseFoodsAdditionGroups = getIdWiseFoods(foods);
    const formatedOrder = formatOrderEditableRecord(order, idWiseFoodsAdditionGroups);
    const stockRestoredFoods = restoreStockOnOrderEdit(foods, formatedOrder);
    
    setTotalAvailableFoods(stockRestoredFoods);
    setAvailableFoods(stockRestoredFoods);
    setOrderRecord(formatedOrder);
    initOrderEditTableSession(formatedOrder.orderId, order.tables, order.orderType, isTableManagement);
    storeOrderedFoodsInSession(formatedOrder);
  }

  useEffect(() => {
    // fetchFoodList();
    fetchRestaurantCategories();
    if (Boolean(orderId)) {
      fetchFoodsAndOrder(orderId)
    }
  }, [orderId]);

  useEffect(() => {
    if (selectedCategory === "all") {
      setAvailableFoods(totalAvailableFoods);
    } else {
      const tmpFoods = totalAvailableFoods.filter((item) => item.categoryId === selectedCategory);

      setAvailableFoods(tmpFoods);
    }
  }, [selectedCategory, totalAvailableFoods]);

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      <CustomLoader />
      <Header title={""} menu={constants.MENU.ORDER} currentMenuKey={"T_4_S_4"} />
      <div className={`flex flex-row bg-prewhite`}>
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.ORDER} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
          <div className="flex flex-col w-full">
            <OrderFormHeaderComponent 
              context={'ORDER'}
              title={`Edit Order ${Boolean(orderRecord.orderNumber) ? `(${orderRecord.orderNumber})` : ""}`}
            />
            <div className="flex flex-col">
              {Boolean(orderRecord.orderId) ? (
                <div>
                  <OrderFormComponent
                    context={1}
                    loadAvailableFoods={loadAvailableFoods}
                    availableCategories={availableCategories}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    selectedFood={selectedFood}
                    setSelectedFood={setSelectedFood}
                    availableFoods={availableFoods}
                    totalAvailableFoods={totalAvailableFoods}
                    orderRecord={orderRecord}
                  />
                </div>
              ) : (
                <div className="w-full h-[70vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
